import HomeList from "../components/HomeList";

const ListHomePage = () => {
  return (
    <HomeList />
  );
};

export default ListHomePage;
